import { render, staticRenderFns } from "./AppointmentChart.vue?vue&type=template&id=2c6ad86a&"
import script from "./AppointmentChart.vue?vue&type=script&lang=js&"
export * from "./AppointmentChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports